import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const LogoutIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="m11.333 4.667-.94.94 1.72 1.726h-6.78v1.334h6.78l-1.72 1.72.94.947L14.667 8l-3.334-3.333ZM2.667 3.333H8V2H2.667c-.734 0-1.334.6-1.334 1.333v9.334c0 .733.6 1.333 1.334 1.333H8v-1.333H2.667V3.333Z" />
  </Icon>
);

export default memo(LogoutIcon);
